<mat-card *ngIf="editInspeccioData" class="inspeccio-card">
  <form #inspForm="ngForm">

    <!-- HEADER -->
    <mat-toolbar class="inspeccio-toolbar">
      <span style="width:90%">Inspection</span>
      <span class="fill-remaining-space"></span>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="desar()" matTooltip="Desar">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="close()" matTooltip="Tancar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <!-- CONTINGUT -->
    <div class="inspeccio-content">

      <!-- FORMULARI -->
      <div class="inspeccio-form">

        <mat-form-field appearance="outline">
          <mat-label>Plate</mat-label>
          <input
            matInput
            name="plate"
            [(ngModel)]="editInspeccioData.plate"
            [matAutocomplete]="autoPlate"
            required>
        </mat-form-field>

        <mat-autocomplete #autoPlate="matAutocomplete">
          <mat-option *ngFor="let plate of plateList" [value]="plate.value">
            {{ plate.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Last inspection</mat-label>
          <input matInput type="text"
                 name="date_last_inspection"
                 [(ngModel)]="editInspeccioData.date_last_inspection">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Expiry date</mat-label>
          <input matInput type="text"
                 name="inspection_expiry_date"
                 [(ngModel)]="editInspeccioData.inspection_expiry_date">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Resultts</mat-label>
          <input matInput type="text"
                 name="inspection_result"
                 [(ngModel)]="editInspeccioData.inspection_result">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Certificate number</mat-label>
          <input matInput type="text"
                 name="inspection_certificate_number"
                 [(ngModel)]="editInspeccioData.inspection_certificate_number">
        </mat-form-field>

      </div>

      <!-- TARGETA VISUAL -->
      <div class="inspeccio-preview">
        <img src="assets/imatges/grenada_inspeccions.jpg" alt="Inspecció">
        <h3>{{ editInspeccioData.plate || '—' }}</h3>
      </div>

    </div>

  </form>
</mat-card>
